type BootstrapResponse = {
    json: () => Promise<unknown>
}

type BootstrapFetch = (url: string, init?: RequestInit) => Promise<BootstrapResponse>

type BootstrapRequestOptions = {
    headers?: HeadersInit
    timeoutMs?: number
    fetchImpl?: BootstrapFetch
}

export async function fetchBootstrapJson(
    url: string,
    {
        headers = {},
        timeoutMs = 0,
        fetchImpl = globalThis.fetch.bind(globalThis),
    }: BootstrapRequestOptions = {},
): Promise<unknown> {
    const controller = timeoutMs > 0 ? new AbortController() : null
    const timeout = controller ? setTimeout(() => controller.abort(), timeoutMs) : null

    try {
        const response = await fetchImpl(url, {
            method: 'GET',
            redirect: 'follow',
            headers,
            ...(controller ? { signal: controller.signal } : {}),
        })
        return await response.json()
    } finally {
        if (timeout !== null) clearTimeout(timeout)
    }
}
